import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, ButtonBase, FormHelperText, Grid, Stack } from "@mui/material";
import moment from "moment";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import ImportantNotice from "../../../components/Common/ImportantNotice";
import CustomAutocomplete from "../../../components/Form/CustomAutocomplete";
import CustomButton from "../../../components/Form/CustomButton";
import CustomSelect from "../../../components/Form/CustomSelect";
import CustomTextField from "../../../components/Form/CustomTextField";
import CustomizedDatePicker from "../../../components/Form/DatePicker";
import Helpers from "../../../helpers/helpers";

const VehicleInfo = ({ formObj, handleFormChange, advertType, isDirectSeller, license_categories, isSingPass, defaultMyinfo, makeList, modelList, bodyList, error,
    windowWidth, setRequestNewOpen, transmissionList, preSelectBodyType, setPreSelectBodyType, defaultColorList, is_manually_fill, setVehicleDetailsOpen }) => {
    const [isImportantNoticeOpen, setIsImportantNoticeOpen] = React.useState(true);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const handleSelectBodyType = (item) => {
        if (preSelectBodyType?.includes(item?.id || item?.bike_type_id)) {
            return
        } else {
            let updatedBodyType = Array.isArray(formObj?.body_type) ? [...formObj?.body_type] : [];
            if (updatedBodyType.includes(item?.id || item?.bike_type_id)) {
                updatedBodyType = updatedBodyType.filter((type) => type !== (item?.id || item?.bike_type_id));
            } else {
                updatedBodyType.push(item?.id || item?.bike_type_id);
            }
            handleFormChange('body_type', updatedBodyType);
        }


    }
    useEffect(() => {
        // if (isDirectSeller && formObj?.is_manually_fill !== true && formObj?.bike_model_id) {
        const body_list = filterModelList?.find((item => item?.id == formObj?.bike_model_id)) || [];
        const body_list_ids = body_list?.bike_types?.map((x) => x.bike_type_id) || [];
        const selectedModel = modelList.find((model) => model.id === formObj?.bike_model_id);
        if (selectedModel) {
            // Set license_category_id from the selected model
            handleFormChange('license_category_id', selectedModel.license_category || "");
            handleFormChange('transmission', selectedModel.transmission || "");
            handleFormChange('engine_cap', selectedModel.engine_cc || "");
            handleFormChange('body_type', body_list_ids || []);
            setPreSelectBodyType(body_list_ids || []);
        }
        // }
    }, [formObj?.bike_model_id])


    const filterModelList = formObj?.bike_make_id ? makeList.find((model) => model.id == formObj?.bike_make_id)?.models : modelList;
    const filterColorList = filterModelList?.find((item => item?.id == formObj?.bike_model_id))?.colours || [];
    const filterBodyList = bodyList;
    const bodyType = Array.isArray(formObj?.body_type) ? formObj?.body_type?.map((type) => filterBodyList.find((item) => (item.bike_type_id || item?.id) == type)?.name) : [];
    return (
        <React.Fragment>
            <Box className="vehicle-info-container">
                <div className="vehicle-selected-absolute">
                    Selected
                </div>
                <div className="text-semibold font-size-18 pt-2">{formObj?.make || '-'} {formObj?.model || ''} {formObj?.manu_year ? (`(${formObj?.manu_year})`) : ''}</div>
                <Box sx={{ display: { lg: 'flex', md: 'flex' }, justifyContent: { lg: 'space-between', md: 'space-between' } }}>
                    <Stack sx={{ flexDirection: { lg: 'row', md: 'row', sm: 'column', xs: 'column' }, gap: 2, mt: 2 }}>
                        <div className="d-flex align-items-center">
                            <div className="subheader-2">Reg. No:</div>
                            <div className="mx-1">{formObj?.reg_no || '-'}</div>
                        </div>
                        {!isSingPass ?
                            <>
                                <div className="d-flex align-items-center">
                                    <div className="subheader-2">Stock ID:</div>
                                    <div className="mx-1">{formObj?.stock_id || '-'}</div>
                                </div> <div className="d-flex align-items-center">
                                    <div className="subheader-2">Body Type:</div>
                                    <div className="mx-1">{bodyType.length > 0 ? bodyType.join(', ') : formObj?.body_type || '-'}</div>
                                </div>
                            </> :
                            <>
                                <div className="d-flex align-items-center">
                                    <div className="subheader-2">COE Expiry Date:</div>
                                    <div className="mx-1">{formObj?.coe_expiry ? moment(formObj?.coe_expiry, "YYYY-MM-DD").format('DD-MM-YYYY') : '-'}</div>
                                </div> <div className="d-flex align-items-center">
                                    <div className="subheader-2">No. of Owner(s):</div>
                                    <div className="mx-1">{formObj?.no_of_owner || '0'}</div>
                                </div>
                            </>
                        }

                    </Stack>
                    <div className="d-flex align-items-end">
                        <ButtonBase onClick={() => setVehicleDetailsOpen(true)} style={{ borderRadius: 10, paddingInline: 5 }}>
                            <div className="d-flex align-items-center" style={{ color: '#B48A3C' }}>View details <Icon icon={'fluent:chevron-right-20-regular'} style={{ marginLeft: 5, height: 16 }} /></div>
                        </ButtonBase>
                    </div>
                </Box>
            </Box>
            {
                isImportantNoticeOpen && (!formObj?.bike_make_id || !formObj?.bike_model_id)
                && (isDirectSeller && is_manually_fill !== true)
                &&
                <Box mt={3}>
                    <ImportantNotice
                        backgroundColor={'#FDF2E2'}
                        color={'#F4C06D'}
                        iconColor={'#1D1B1B'}
                        iconName={'solar:danger-triangle-linear'}
                        message={
                            <>
                                <div className="text-bold mb-2">Value doesn’t match our make or model list.</div>
                                <div >Please edit to select a valid option or contact admin to update the correct model.</div>
                                {
                                    <Box className="mt-3 align-items-center" sx={{ display: { lg: 'flex', md: 'block' }, marginTop: { md: 2, sm: 2, xs: 2 } }}>
                                        <CustomButton
                                            title={'Request New Make / Model'}
                                            press={() => { setRequestNewOpen(true) }}
                                            marginRight={10}
                                            padding={"23px"}
                                        />
                                        <CustomButton
                                            title={'Dismiss'}
                                            press={() => { setIsImportantNoticeOpen(false) }}
                                            backgroundColor={'#F9F9F9'}
                                            textColor={'#1D1B1B'}
                                            borderStyle={'1px solid #F9F9F9'}
                                            marginTop={windowWidth <= 375 ? 5 : 0}
                                        />
                                    </Box>
                                }
                            </>
                        }
                    />
                </Box>
            }
            {
                (isDirectSeller && is_manually_fill === true) &&
                <Stack sx={{ flexDirection: { xs: 'column', sm: 'row' }, mt: 2, flexWrap: 'wrap', gap: { xs: 0, sm: 1 } }}>
                    Can't find your make or model ?
                    <div style={{ color: '#B48A3C', cursor: 'pointer' }} onClick={() => { setRequestNewOpen(true) }}>Request to add a new one.</div>

                </Stack>
            }
            <Box mt={3}>
                <div className="text-semibold">Make & Model</div>
                <Grid container spacing={2}>
                    {isSingPass &&
                        <>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    title={'Make (Myinfo)'}
                                    placeholder={'Make'}
                                    isOptional={true}
                                    values={defaultMyinfo?.make || ''}
                                    onChange={(e) => handleFormChange('myinfo_make', e)}
                                    error={error?.myinfo_make}
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    title={'Model (Myinfo)'}
                                    placeholder={'Model'}
                                    isOptional={true}
                                    values={defaultMyinfo?.model || ''}
                                    onChange={(e) => handleFormChange('myinfo_model', e)}
                                    error={error?.myinfo_model}
                                    disabled={true}

                                />
                            </Grid>
                        </>}
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomAutocomplete
                            title={'Make'}
                            placeholder={'Make'}
                            values={formObj?.bike_make_id || null}
                            onChange={(e, value) => {
                                handleFormChange('bike_make_id', value?.id);
                                handleFormChange('body_type', []);
                                setPreSelectBodyType([]);
                            }}
                            freeSolo={false}
                            data={makeList}
                            disabled={isSingPass}
                            labelName="name"
                            valueName="id"
                            error={error?.bike_make_id}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomAutocomplete
                            title={'Model'}
                            placeholder={'Model'}
                            values={formObj?.bike_model_id || null}
                            onChange={(e, value) => {
                                handleFormChange('bike_model_id', value?.id);
                            }}
                            data={filterModelList}
                            labelName="name"
                            valueName="id"
                            error={error?.bike_model_id}
                            InputProps={{
                                //if not match with admin setup
                                // endAdornment:
                                //     <AppTooltip
                                //         icon="solar:danger-triangle-linear"
                                //         iconColor="#D13536"
                                //         backgroundColor={'#000000'}
                                //         textColor={'white'}
                                //         message={'Value doesn’t match our make or model list. Please edit to select a valid option or contact admin to update the correct model.'}
                                //     />
                            }}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomTextField
                            title={'Year of Manufacture'}
                            placeholder={'Year of Manufacture'}
                            isOptional={true}
                            disabled={isSingPass}
                            values={formObj?.manu_year || ''}
                            onChange={(e) => handleFormChange('manu_year', e)}
                            error={error?.manu_year}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomSelect
                            title={'License Category'}
                            placeholder={'License Category'}
                            values={formObj?.license_category_id || ''}
                            onChange={(e) => handleFormChange('license_category_id', e)}
                            data={license_categories}
                            labelName={'name'}
                            valueName={'id'}
                            error={error?.license_category_id}
                        />
                    </Grid>
                    {isSingPass &&
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <CustomTextField
                                title={'Registration Number'}
                                values={formObj?.reg_no || ''}
                                disabled={isSingPass}
                                onChange={(e) => handleFormChange('registration_number', e)}
                                error={error?.registration_number}
                            />
                        </Grid>
                    }
                </Grid>
            </Box>
            {advertType !== "used" &&
                <Box mt={4}>
                    <div className="text-semibold">Primary Colour <span className="optional-label me-2">Optional</span></div>
                    <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                        {filterColorList?.length > 0 ? filterColorList.map((color, index) => (
                            <div className={formObj?.bike_model_colour_id && (formObj?.bike_model_colour_id === color?.id) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => { handleFormChange('colour_text', null); handleFormChange('bike_model_colour_id', formObj?.bike_model_colour_id === color?.id ? null : color?.id); }}>
                                {color?.name}
                            </div>
                        )) || <div className="subheader-2">No Data Available</div> : defaultColorList.map((color, index) => (
                            <div className={formObj?.colour_text && (formObj?.colour_text === color?.value) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => { handleFormChange('colour_text', formObj?.colour_text === color?.value ? null : color?.value); handleFormChange('bike_model_colour_id', null); }}>
                                {color?.label}
                            </div>
                        )) || <div className="subheader-2">No Data Available</div>}
                    </Stack>
                </Box>}
            <Box mt={4}>
                <div className="text-semibold">Body Type</div>
                <div className="subheader-2">Select one or more</div>
                <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                    {filterBodyList?.length > 0 ? filterBodyList?.map((item, index) => (
                        <div className={preSelectBodyType?.length > 0 && preSelectBodyType?.includes(item?.id || item?.bike_type_id) ? "default-selected" : formObj?.body_type?.includes(item?.id || item?.bike_type_id) ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => handleSelectBodyType(item)}>
                            {item?.name}
                        </div>
                    )) : <div className="subheader-2">No Data Available</div>}
                </Stack>
                {error?.body_types && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.body_types || ""}</FormHelperText>}
            </Box>
            <Box mt={4}>
                <div className="text-semibold">Specification</div>
                <Grid container spacing={2}>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomSelect
                            title={'Transmission'}
                            placeholder={'Transmission'}
                            values={formObj?.transmission || ''}
                            onChange={(e) => handleFormChange('transmission', e)}
                            data={transmissionList}
                            labelName={'name'}
                            valueName={'id'}
                            error={error?.transmission}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={12} xs={12}>
                        <CustomTextField
                            title={'Engine Capacity (CC)'}
                            placeholder={'Engine Capacity (CC)'}
                            values={formObj?.engine_cap}
                            type={'number'}
                            onChange={(e) => handleFormChange('engine_cap', e)}
                            error={error?.engine_cc}
                        />
                    </Grid>
                    {
                        (isDirectSeller || advertType === 'used') &&
                        <>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomizedDatePicker
                                    title={"Registration Date"}
                                    values={(formObj?.reg_date || formObj?.first_reg_date) && new Date(formObj?.reg_date || formObj?.first_reg_date)}
                                    placeholder={"dd/mm/yyyy"}
                                    disabled={isSingPass}
                                    setFormValues={(e) => handleFormChange('reg_date', e)}
                                    error={error?.reg_date || error?.registration_date}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomizedDatePicker
                                    title={"COE Expiry Date"}
                                    values={formObj?.coe_expiry && new Date(formObj?.coe_expiry)}
                                    placeholder={"dd/mm/yyyy"}
                                    disabled={isSingPass}
                                    setFormValues={(e) => handleFormChange('coe_expiry', e)}
                                    error={error?.coe_expiry}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    title={<>Mileage (KM)</>}
                                    placeholder={'Mileage (KM)'}
                                    type={'number'}
                                    isOptional={true}
                                    values={formObj?.mileage ?? ""}
                                    onChange={(e) => handleFormChange('mileage', e)}
                                    error={error?.mileage_in_km}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    title={'No. of Owner(s)'}
                                    placeholder={'No. of Owner(s)'}
                                    type={'number'}
                                    disabled={isSingPass}
                                    values={formObj?.no_of_owner ?? ""}
                                    onChange={(e) => handleFormChange('no_of_owner', e)}
                                    error={error?.no_of_previous_owners}
                                />
                            </Grid>
                        </>
                    }
                </Grid>
            </Box>
            {
                (!isDirectSeller && advertType === 'new') &&
                <Box mt={4}>
                    <div className="text-semibold">Vehicle Source <span className="optional-label me-2">Optional</span></div>
                    <Stack sx={{ flexDirection: 'row', gap: 2, mt: 2, flexWrap: 'wrap' }}>
                        {Helpers.vehicleSourceList.map((source, index) => (
                            <div className={formObj?.vehicle_source === source.value ? "vehicle-small-button-selected" : "vehicle-small-button"} onClick={() => handleFormChange('vehicle_source', formObj?.vehicle_source === source.value ? null : source.value)}>
                                {source.label}
                            </div>
                        ))}
                    </Stack>
                    {error?.vehicle_source && <FormHelperText className='d-flex align-items-center m-0 mt-1' sx={{ color: "#BA2727" }}><Icon icon={'fluent:error-circle-24-filled'} height={14} width={14} />{error?.vehicle_source || ""}</FormHelperText>}
                </Box>
            }
        </React.Fragment>
    )
}

function mapStateToProps({ General, Layout }) {
    return {
        windowWidth: Layout.currentWidth,
        makeList: General.bike_makes,
        modelList: General.bike_models,
        bodyList: General.bike_types,
        license_categories: General.license_categories,
        transmissionList: General.transmissions,
        defaultColorList: General.default_colours,
    };
}


export default connect(mapStateToProps)(VehicleInfo);